import axios from 'axios';
import {
  GRATUITIES,
  V1_GRATUITIES,
  GRATUITY_BY_ID,
  CREATE_ALL_OUTLET,
} from './constants';

const reject = error => {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.code && data.code === '0014-0001') {
      eobj = new Error(`Gratuity does not found or already removed`);
    } else if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
};

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/gratuities_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getGratuities(params) {
  return axios.get(GRATUITIES, { withCredentials: true, params }).catch(reject);
}

export function getGratutityById(id, name, params) {
  return axios
    .get(GRATUITY_BY_ID(id), { params, withCredentials: true })
    .catch(error => reject(error, name));
}

export function postGratuity(data, params) {
  return axios
    .post(V1_GRATUITIES, data, { params, withCredentials: true })
    .catch(reject);
}

export function deleteGratuity(id, name, params) {
  return axios
    .delete(GRATUITY_BY_ID(id), { params, withCredentials: true })
    .catch(error => reject(error, name));
}

export function putGratuity(id, data, params) {
  return axios
    .put(GRATUITY_BY_ID(id), data, { params, withCredentials: true })
    .catch(error => reject(error, data.name));
}

export function postCreateAllOutlet(data, params) {
  return axios
    .post(CREATE_ALL_OUTLET, data, { params, withCredentials: true })
    .catch(reject);
}
